module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-SemiBold-039bed2cf3ff01a0609834c501344c80.svg";